import { PlayerService } from "./PlayerService";

type handleCheckCodeResponse = {
    correct: boolean;
};
export class KeypadService {
    private _playerService: PlayerService = new PlayerService();
    public async handleCheckCode(code: string): Promise<boolean> {
        const response: Response = await fetch(`${VITE_API_URL}backpack-routes/check-code/${code}`,
            {
                method: "GET",
                headers: {
                    "X-PlayerSessionId": this._playerService.getPlayerSessionId(),
                },
            }

        );

        const data: handleCheckCodeResponse = await response.json() as handleCheckCodeResponse;

        return data.correct;
    }
}
